// chat-skeleton.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-chat-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
     <div class="tw-space-y-4 tw-animate-pulse">
      
      <!-- Received Message Skeleton (Left) -->
      <div class="tw-group tw-relative tw-p-3 tw-flex">
        <div class="tw-flex tw-flex-col tw-max-w-[80%] lg:tw-max-w-[70%] tw-gap-1 tw-items-start">
          
          <!-- Avatar and Name -->
          <div class="tw-relative tw-flex-shrink-0">
            <div class="tw-flex tw-items-center tw-gap-x-2 tw-pt-1">
              <div class="tw-w-9 tw-h-9 tw-rounded-full tw-bg-gray-300 dark:tw-bg-gray-600"></div>
              <div class="tw-h-4 tw-w-20 tw-bg-gray-300 dark:tw-bg-gray-600 tw-rounded"></div>
            </div>
          </div>

          <!-- Message Bubble -->
          <div class="tw-relative tw-rounded-2xl tw-px-4 tw-py-3 tw-bg-gray-200 dark:tw-bg-gray-700 tw-min-w-[100px] sm:tw-min-w-[150px] md:tw-min-w-[200px] tw-max-w-md">
            <!-- Text Lines -->
            <div class="tw-space-y-2 tw-mb-2">
              <div class="tw-h-4 tw-bg-gray-400 dark:tw-bg-gray-600 tw-rounded tw-w-full"></div>
              <div class="tw-h-4 tw-bg-gray-400 dark:tw-bg-gray-600 tw-rounded tw-w-3/4"></div>
            </div>
            <!-- Time -->
            <div class="tw-flex tw-justify-end">
              <div class="tw-h-3 tw-w-12 tw-bg-gray-400 dark:tw-bg-gray-500 tw-rounded"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sent Message Skeleton (Right) -->
      <div class="tw-group tw-relative tw-p-3 tw-flex tw-justify-end">
        <div class="tw-flex tw-flex-col tw-max-w-[80%] lg:tw-max-w-[70%] tw-gap-1 tw-items-end">
          
          <!-- Name -->
          <div class="tw-relative tw-flex-shrink-0">
            <div class="tw-flex tw-items-center tw-justify-end tw-pt-1">
              <div class="tw-h-4 tw-w-12 tw-bg-gray-300 dark:tw-bg-gray-600 tw-rounded"></div>
            </div>
          </div>

          <!-- Message Bubble -->
          <div class="tw-relative tw-rounded-2xl tw-px-4 tw-py-3 tw-bg-gray-200 dark:tw-bg-gray-700 tw-min-w-[100px] sm:tw-min-w-[150px] md:tw-min-w-[200px] tw-max-w-md">
            <!-- Text Lines -->
            <div class="tw-space-y-2 tw-mb-2">
              <div class="tw-h-4 tw-bg-gray-400 dark:tw-bg-gray-600 tw-rounded tw-w-full"></div>
              <div class="tw-h-4 tw-bg-gray-400 dark:tw-bg-gray-600 tw-rounded tw-w-2/3"></div>
            </div>
            <!-- Time and Status -->
            <div class="tw-flex tw-items-center tw-justify-end tw-gap-2">
              <div class="tw-h-3 tw-w-12 tw-bg-gray-400 dark:tw-bg-gray-500 tw-rounded"></div>
              <div class="tw-h-3 tw-w-4 tw-bg-gray-400 dark:tw-bg-gray-500 tw-rounded"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Short Message Skeleton (Left) -->
      <div class="tw-group tw-relative tw-p-3 tw-flex">
        <div class="tw-flex tw-flex-col tw-max-w-[80%] lg:tw-max-w-[70%] tw-gap-1 tw-items-start">
          
          <!-- Avatar and Name -->
          <div class="tw-relative tw-flex-shrink-0">
            <div class="tw-flex tw-items-center tw-gap-x-2 tw-pt-1">
              <div class="tw-w-9 tw-h-9 tw-rounded-full tw-bg-gray-300 dark:tw-bg-gray-600"></div>
              <div class="tw-h-4 tw-w-16 tw-bg-gray-300 dark:tw-bg-gray-600 tw-rounded"></div>
            </div>
          </div>

          <!-- Short Message Bubble -->
          <div class="tw-relative tw-rounded-2xl tw-px-4 tw-py-3 tw-bg-gray-200 dark:tw-bg-gray-700 tw-min-w-[80px] sm:tw-min-w-[120px]">
            <!-- Single Text Line -->
            <div class="tw-mb-2">
              <div class="tw-h-4 tw-bg-gray-400 dark:tw-bg-gray-600 tw-rounded tw-w-16"></div>
            </div>
            <!-- Time -->
            <div class="tw-flex tw-justify-end">
              <div class="tw-h-3 tw-w-10 tw-bg-gray-400 dark:tw-bg-gray-500 tw-rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.7;
      }
    }
    
    .tw-animate-pulse {
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }
  `]
})
export class ChatSkeletonComponent { }
